(function() {
    'use strict';

    angular.module( APP_ID )
        .controller( 'ContentSwitcherController', ContentSwitcherController );

    /**
     * Handles switching between an international and domestic content using
     * simple toggle button.
     *
     * @param {ng.IScope} $scope
     * @param {LoggerFactory} LoggerFactory
     * @param {function} ngDialog
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {Object} TEXTS
     */
    function ContentSwitcherController(
        $scope,
        LoggerFactory,
        ngDialog,
        ContentSwitchingService,
        TEXTS
    ){
        // Helping members.

        /** @type {angular.IController} */
        var vm       = this;

        /** @type {Logger} */
        //var logger = LoggerFactory.createLogger( 'ContentSwitcherController', false );



        var dialog = undefined;


        /* ===== EXPOSE ON THE SCOPE ======================================== */

        vm._ = TEXTS.CONTENT_SWITCHER;


        /* ===== CONTROLLER'S PUBLIC API ==================================== */

        // Members (+ their defaults)
        vm.isInternationalSelected = ContentSwitchingService.contentType;

        // Methods
        vm.showDialog              = showDialog;


        /* ===== RUN ON INSTANTIATION ======================================= */

        /** @constructor */
        (function init(){
            setWatchers();
            updateSwitchValue();

            ContentSwitchingService.reevaluateSettingsInputRequirement();
        })();



        /* ===== CONTROLLER'S PUBLIC METHODS ================================ */


        /** Initialises content switcher dialog. */
        function showDialog( $event ) {
            if ( $event ) $event.preventDefault();

            dialog = ngDialog.open({
                template:     'app/views/partials/widgets/dialog-international-switcher.html',
                controller:   DialogSwitcherController,
                controllerAs: 'vm',
                className:    'dialog',
                ariaRole:     'dialog'
            });

            dialog.closePromise.then( onDialogClose );
        }


        /* ===== PRIVATE FUNCTIONS ========================================== */

        function setWatchers() {
            $scope.$watch( ContentSwitchingService.contentType, updateSwitchValue );

            $scope.$watch(
                function() {
                    return ContentSwitchingService.isSettingsInputRequired;
                },
                function( isDialogRequired ) {

                    if ( isDialogRequired ) {
                        // If location != 'nz' && !ContentSwitchingService.isSettingsInitialised()
                        // -> Open dialog on runtime
                        showDialog();
                    }
                }
            );
        }

        function onDialogClose() {
            // No cookie + ?international => revert to default
            if ( !ContentSwitchingService.isSettingsInitialised() && ContentSwitchingService.isInternational() ) {
                ContentSwitchingService.switchContentToDefault();
            }

            updateSwitchValue();
        }

        function updateSwitchValue() {
            vm.isInternationalSelected = ContentSwitchingService.isInternational();
        }
    }


    ContentSwitcherController.$inject   = [ '$scope', 'LoggerFactory', 'ngDialog', 'ContentSwitchingService', 'TEXTS' ];


    /**
     * Prepares data and manipulation logic for content switcher dialog
     *
     * _Hint: Switching dialog's logic - can be moved out, if necessary._
     *
     * @param {ng.IScope} $scope
     * @param {LoggerFactory} LoggerFactory
     * @param {Utils} Utils
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {Config} TEXTS
      */
    function DialogSwitcherController(
        $scope,
        LoggerFactory,
        Utils,
        ContentSwitchingService,
        TEXTS
    ){
        // Helping members.

        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'DialogSwitcherController', false );

        /** @type {angular.IController} */
        var vm       = this;





        /* ===== EXPOSE ON THE SCOPE ======================================== */


        $scope._     = TEXTS.CONTENT_SWITCHER.DIALOG;
        $scope.Utils = Utils;





        /* ===== CONTROLLER'S PUBLIC API ==================================== */


        // Members (+ their defaults)
        vm.countriesList                  = [];
        vm.selectedNationality            = ContentSwitchingService.userSettings.nationalityCountry;
        vm.isSelectedNationalityDomestic  = false;
        vm.isAutomaticallyOpened          = ContentSwitchingService.isSettingsInputRequired;

        // *MUST BE* present to make `ui-select` directive work properly
        vm.selectConfig           = {
            template:           'select2',
            dropdownAutoWidth:  true,
        }

        // Methods
        vm.checkSelectionConstraints      = checkSelectionConstraints;
        vm.saveInternationalChanges       = saveInternationalChanges;
        vm.saveDomesticChanges            = saveDomesticChanges;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        (function init(){
            logger.debug( "Dialog is being loaded..." );

            ContentSwitchingService.getCountriesList().then( function( countriesList ) {
                vm.countriesList = countriesList;

                checkSelectionConstraints();
            }).catch( function( errorObject ) {
                logger.error( 'Unable to render a selector with a list of all countries.', errorObject );
            });
        })();





        /* ===== CONTROLLER'S PUBLIC METHODS ================================ */


        function checkSelectionConstraints() {
            vm.isSelectedNationalityDomestic = ContentSwitchingService.isCountryDomestic( vm.selectedNationality );
        }


        function saveInternationalChanges(){
            if ( !vm.selectedNationality || vm.isSelectedNationalityDomestic ) return;

            updateNationality();
            ContentSwitchingService.switchContentTo( ContentSwitchingService.CONTENT_TYPES.INTERNATIONAL );
            ContentSwitchingService.saveSettingsToCookie();
            $scope.closeThisDialog( true );
            logger.debug( "Saving changes for international and closing dialog..." );
        }


        function saveDomesticChanges() {
            if ( vm.isSelectedNationalityDomestic ){
                updateNationality();
            } else {
                ContentSwitchingService.setNationalityToDefault();
            }

            ContentSwitchingService.switchContentTo( ContentSwitchingService.CONTENT_TYPES.DOMESTIC );
            ContentSwitchingService.saveSettingsToCookie();
            $scope.closeThisDialog( true );
            logger.debug( "Saving changes for domestic and closing dialog..." );
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function updateNationality() {
            ContentSwitchingService.setNationalityCountry( vm.selectedNationality );
        }
    }


    DialogSwitcherController.$inject    = [ '$scope', 'LoggerFactory', 'Utils', 'ContentSwitchingService', 'TEXTS' ];
})();

